import React from 'react';
import {Bar} from 'react-chartjs-2';
import styles from "./MainChart.module.css";

export default ({data, title}) => {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: false,
            text: title
        },
        tooltips: {
            mode: 'index',
            intersect: true
        },
        scales: {
            yAxes: [{
                type: 'linear',
                display: true,
                position: 'left',
                id: 'y-axis-1',
            }, {
                type: 'linear',
                display: true,
                position: 'right',
                id: 'y-axis-2',
                gridLines: {
                    drawOnChartArea: false
                }
            }],
        }
    };

    return (
      <div className={styles.chart}>
        <Bar data={data} options={options} />
      </div>
    )
}